import abstractModel from '../../core/MercatelyModel';
import { MERCATELY_API } from '../../constants/AppConstants';

const resource = `${MERCATELY_API}/entity_metadata`;

const model = {
  ...abstractModel(resource),
  upsertContifico: (payload) => abstractModel(`${resource}/upsert_contifico`).save(payload),
  upsertContificoSettings: (payload) => abstractModel(`${resource}/upsert_contifico_settings`).save(payload),
  disconnectContifico: () => abstractModel(`${resource}/disconnect_contifico`).remove({}),
  upsertVtex: (payload) => abstractModel(`${resource}/upsert_vtex`).save(payload),
  upsertVtexSettings: (payload) => abstractModel(`${resource}/upsert_vtex_settings`).save(payload),
  disconnectVtex: () => abstractModel(`${resource}/disconnect_vtex`).remove()
};

export default model;
